module.exports = __webpack_public_path__ + "img/hr.7cfd25b.svg";